import React from "react";
import { PageShell } from "../components/PageShell";
export function Partners() {
  return <PageShell title="Partenaires" intro="Ils soutiennent le 50ème anniversaire du parapente à Mieussy." data-id="element-194" data-mp="z8wgpgkchtm5" />;
}